import * as React from 'react';
import { StyledBox } from './TextBox.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'span';
function TextBox(props, ref) {
  const {
    as = defaultElement,
    fontSize,
    fontWeight,
    lineHeight,
    fontStyle,
    letterSpacing,
    ...htmlAttributes
  } = props;
  const styledProps = {
    $fontSize: fontSize,
    $fontWeight: fontWeight,
    $lineHeight: lineHeight,
    $fontStyle: fontStyle,
    $letterSpacing: letterSpacing
  };
  return /*#__PURE__*/_jsx(StyledBox, {
    forwardedAs: as,
    ref: ref,
    ...styledProps,
    ...htmlAttributes
  });
}
export default /*#__PURE__*/React.forwardRef(TextBox);